import { useTranslation } from "react-i18next";
import CongratulationIcon from "../assets/svg/congratulations.svg";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import { useNavigate } from "react-router-dom";
export default function Congratulation() {
  const { t, i18n } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.homepage",
  });
  const navigate = useNavigate();
  const onRegister = () => {
    navigate("/candidate/choose-program");
  };
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="p-4 flex flex-col justify-center items-center">
        <div className="w-full flex justify-center items-center">
          <img
            className={"h-36 w-auto"}
            src={CongratulationIcon}
            alt="Congratulation Icon"
          />
        </div>
        <div className="w-full text-center flex flex-col gap-2 justify-center items-center mt-6">
          <h4 className="text-gray-800  text-xl leading-8 font-semibold">
            {t("congratulation")}
          </h4>
          <p className="text-gray-400  font-medium text-base mb-4">
            {t("signDone")}
          </p>
          <button
            type="submit"
            data-cy="submit"
            className="flex justify-center items-center gap-3 w-[198px] h-[42px] rounded-md border border-transparent bg-brandblue-600 text-base font-medium text-white shadow-sm hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2 disabled:bg-gray-400"
            onClick={onRegister}
          >
            {t("sign")}
            <ArrowLeftIcon className="w-5 ltr:rotate-180" />
          </button>
        </div>
      </div>
    </div>
  );
}
